import pathUrl from "./path"
import instance from './request'


const axios = instance;
const api = {
    // upload data =========================================================================
    getTemplateFile() {
        return axios.get(pathUrl.baseUrl + "/the_biomarker/api-template-file");
    },


    // Contact Part=====================================================================
    postContactUs(post_data) {
        return axios({
            method: "post",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            },
            data: post_data, //发送post请求，使用data关键字接收请求参数
            url: pathUrl.baseUrl + "/the_biomarker/contactus",
        });
    },

    // submitMission =========================================================================
    submitMission(post_data) {
        return axios({
            method: "post",
            headers: {
                "Content-Type": "application/json",
            },
            data: post_data,
            url: pathUrl.baseUrl + "/the_biomarker/submitMission",
        });
    },
    getProgress(id) { // USE
        return axios.get(pathUrl.baseUrl + "/the_biomarker/getProgress/" + id);
    },
    getResult(id) { // USE
        return axios.get(pathUrl.baseUrl + "/the_biomarker/getResult/" + id);
    },
    getResultAll(id) { // USE
        return axios.get(pathUrl.baseUrl + "/the_biomarker/getResultAll/" + id);
    },
    getResultMain(id) { // USE
        return axios.get(pathUrl.baseUrl + "/the_biomarker/getResultMain/" + id);
    },





    

    // Data Detail Page==========================================================================
    postMoleculeInformation(post_data) {
        return axios({
            method: "post",
            headers: {
                "Content-Type": "application/json",
            },
            data: post_data,
            url: pathUrl.baseUrl + "/the_biomarker/postMoleculeInformation",
        });
    },
    getExpInter(id) {
        return axios.get(pathUrl.baseUrl + "/the_biomarker/getExpInter/" + id);
    },
    postMoleculeLocation(post_data) {
        return axios({
            method: "post",
            headers: {
                "Content-Type": "application/json",
            },
            data: post_data,
            url: pathUrl.baseUrl + "/the_biomarker/postMoleculeLocation",
        });
    },
    postMoleculeInteraction2Level(post_data) {
        return axios({
            method: "post",
            headers: {
                "Content-Type": "application/json",
            },
            data: post_data,
            url: pathUrl.baseUrl + "/the_biomarker/postMoleculeInteraction2Level",
        });
    },
    getOrganismLocationTree() {
        return axios.get(pathUrl.baseUrl + "/the_biomarker/getOrganismLocationTree");
    },
    postOrganismLocationTree(post_data) {
        return axios({
            method: "post",
            headers: {
                "Content-Type": "application/json",
            },
            data: post_data,
            url: pathUrl.baseUrl + "/the_biomarker/postOrganismLocationTree",
        });
    },

    getCompartmentInformation(id) { // USE
        return axios.get(pathUrl.baseUrl + "/the_biomarker/getCompartmentInformation/" + id);
    },
    getCompartmentMolecule(id) {// USE
        return axios.get(pathUrl.baseUrl + "/the_biomarker/getCompartmentMolecule/" + id);
    },
    getCompartmentInteraction(id) {// USE
        return axios.get(pathUrl.baseUrl + "/the_biomarker/getCompartmentInteraction/" + id);
    },
    getCompartmentExpInter(id) {// USE
        return axios.get(pathUrl.baseUrl + "/the_biomarker/getCompartmentExpInter/" + id);
    },
    getInteractionDisease(id) {// USE
        return axios.get(pathUrl.baseUrl + "/the_biomarker/getInteractionDisease/" + id);
    },



    // Search Result Page==========================================================================
    // 关键词更新
    updateGroupKey(post_data) {
        return axios({
            method: "post",
            headers: {
                "Content-Type": "application/json",
            },
            data: post_data, //发送post请求，使用data关键字接收请求参数
            url: pathUrl.baseUrl + "/the_biomarker/updateGroupKey",
        });
    },
    // SQL 查询
    postSqlInquire(post_data) {
        return axios({
            method: "post",
            headers: {
                "Content-Type": "application/json",
            },
            data: post_data, //发送post请求，使用data关键字接收请求参数
            url: pathUrl.baseUrl + "/the_biomarker/postSqlInquire",
        });
    },
    postSqlInquireCompartment(post_data) {
        return axios({
            method: "post",
            headers: {
                "Content-Type": "application/json",
            },
            data: post_data, //发送post请求，使用data关键字接收请求参数
            url: pathUrl.baseUrl + "/the_biomarker/postSqlInquireCompartment",
        });
    },
    // Blast 结果查询
    postSequenceResult(post_data) {
        return axios({
            method: "post",
            headers: {
                "Content-Type": "application/json",
            },
            data: post_data, //发送post请求，使用data关键字接收请求参数
            url: pathUrl.baseUrl + "/the_biomarker/postSequenceResult",
        });
    },








    getProteinExperiments(id) {// USE
        return axios.get(pathUrl.baseUrl + "/the_biomarker/api-data-protein-experiments/" + id);
    },
    getOrganismInformation(id) {// USE
        return axios.get(pathUrl.baseUrl + "/the_biomarker/api-data-organism-info/" + id);
    },
    getOrganismExperiments(id) {// USE
        return axios.get(pathUrl.baseUrl + "/the_biomarker/api-data-organism-experiments/" + id);
    },

    getHomologousProteinInformation(id) {// USE
        return axios.get(pathUrl.baseUrl + "/the_biomarker/api-data-homo-info/" + id);
    },
    getHomologousProteinExperiments(id) {// USE
        return axios.get(pathUrl.baseUrl + "/the_biomarker/api-data-homo-experiments/" + id);
    },













    








}

export default api;